import React from 'react';
import { Heart } from 'lucide-react';

export const RSVPPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="rsvp-page-closed">
      {/* Header */}
      <section className="py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-display text-5xl md:text-7xl mb-6 animate-fade-in text-[#e17c3b]">RSVP</h1>
          <p className="text-[#8d5f3f]/70 text-lg max-w-2xl mx-auto animate-fade-in delay-100">
            Inscriptions closes
          </p>
        </div>
      </section>

      {/* Closure Message */}
      <section className="px-6 md:px-12 pb-16" data-testid="rsvp-closed-section">
        <div className="max-w-xl mx-auto">
          <div className="bg-[#fcf6f1] border border-[#e8ddd4] rounded-2xl p-8 md:p-12 animate-slide-up delay-200 shadow-md text-center">
            <div className="w-20 h-20 rounded-full bg-[#e17c3b]/10 flex items-center justify-center mx-auto mb-8 animate-fade-in">
              <Heart className="w-10 h-10 text-[#e17c3b]" fill="#e17c3b" />
            </div>

            <h2 className="font-display text-2xl md:text-3xl text-[#8d5f3f] mb-6 leading-snug" data-testid="rsvp-closed-title">
              Les confirmations sont officiellement closes.
            </h2>

            <div className="w-16 h-px bg-[#e17c3b]/40 mx-auto mb-6"></div>

            <p className="text-[#8d5f3f]/85 text-base md:text-lg leading-relaxed mb-4" data-testid="rsvp-closed-message">
              Un immense merci à tous ceux qui ont répondu présent.
            </p>

            <p className="text-[#8d5f3f] text-base md:text-lg leading-relaxed font-medium italic">
              Nous avons hâte de célébrer avec vous à Séville !
            </p>
          </div>
        </div>
      </section>

      {/* Bottom Image - Single image matching form width */}
      <section className="py-8 px-6 md:px-12" data-testid="rsvp-bottom-images">
        <div className="max-w-xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img
              src="https://customer-assets.emergentagent.com/job_wedding-invite-gc/artifacts/cpjmqh97_RSVP.png"
              alt="RSVP"
              className="w-full h-64 md:h-72 object-cover"
              loading="lazy"
              decoding="async"
              data-testid="rsvp-bottom-image"
            />
          </div>
        </div>
      </section>
    </div>
  );
};
